import React from 'react';

import autoBind from 'react-autobind';

// import other components within the same project here

class LocaleMapState extends React.Component {
  constructor(props) {
    super(props);
    this.refs = React.createRef();

    // state variables here
    this.state = {
      // aNumber : 1,
      // aString: "abc",
      // anArray: [],
      // anObject: {},
      bounds: null,
      center: { lat: 22.34, lng: 114.12 },
      zoom: 12,
      boundsChanged: false,
      mapTypeId: "roadmap",
    };
    autoBind(this);
  }

  updateState() {
    if (this.props.parent.refs.localeMapView != null) {
      let map = this.props.parent.refs.localeMapView.state.map;
      let center = {
        lat: map.center.lat,
        lng: map.center.lon,
      };
      let zoom = map.zoom;
      // let mapType = map.getMapTypeId();
      let mapType = "roadmap";
      this.setState({
        center: center,
        zoom: zoom,
        mapTypeId: mapType,
      });
      this.state.center = center;
      this.state.zoom = zoom;
      this.state.mapTypeId = mapType;
      this.state.bounds = map.bounds;
      // console.log('updated bounds which should not be null.');
    }
  }

  setCenter(center) {
    this.setState({ center: center });
    this.state.center = center;
  }

  setBoundsChanged(value) {
    this.setState({ boundsChanged: value });
    this.state.boundsChanged = value;
  }

  render() {
      return (
        <div>

        </div>
      )
  }
}

export default LocaleMapState;
